import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { FC, useState } from "react";
import useAllProductOfferings from "../../../services/useAllProductOfferings";
import { Option } from "../../../types/core";
import useAddOrderItem from "../../../services/useAddOrderItem";
import { IProductOffering } from "../../../types/products";

interface Props {
  fairId: number;
  orderId: number;
}

const AddItem: FC<Props> = ({ fairId, orderId }) => {
  const [open, setOpen] = useState(false);
  const { mutate } = useAddOrderItem(orderId, fairId);
  const { data: productOfferings } = useAllProductOfferings(fairId, open);
  const [amount, setAmount] = useState(1);
  const [product, setProduct] = useState<null | Option>(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setProduct(null);
    setAmount(1);
  };

  const addItem = () => {
    if (product && product.value && amount > 0) {
      mutate({ amount, productOfferingId: product.value });
      handleClose();
    }
  };

  const availableOfferings =
    productOfferings?.filter(
      (productOffering: IProductOffering) =>
        productOffering.available && productOffering.has_stock,
    ) ?? [];

  return (
    <Box>
      <IconButton onClick={handleOpen}>
        <Add />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { overflow: "visible" },
        }}
      >
        <DialogTitle>Adicionar item ao pedido</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Selecione o produto e a quantidade abaixo:
          </DialogContentText>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Autocomplete
              value={product}
              onChange={(e, newValue) => {
                setProduct(newValue);
              }}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              disablePortal
              options={availableOfferings.map(
                (productOffering: IProductOffering) => ({
                  label: `${productOffering.product.name} - ${productOffering.product.producer.name}`,
                  value: productOffering.id,
                }),
              )}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label="Buscar produto" />
              )}
            />
            <TextField
              label="Quantidade"
              type="number"
              onChange={(e) => {
                setAmount(parseInt(e.target.value, 10) || 0);
              }}
              inputProps={{ min: 1 }}
              value={amount}
              variant="outlined"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button disabled={!product || amount < 1} onClick={addItem}>
            Adicionar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddItem;
